<template>
  <div class="toplist-container" @click="$router.push({ name: 'TopList' })">
    <div class="title">好评TOP榜</div>
    <div class="subtitle">优选精品好货</div>
    <div class="goods">
      <div class="good recommend">
        <div class="img">
          <div class="swiper-wrapper">
            <Swipe :show-indicators="false" :autoplay="3000">
              <SwipeItem
                v-for="(item, index) in recommend"
                :key="'recommend-' + index"
              >
                <div
                  class="img-wrapper"
                  :style="{ backgroundImage: 'url(' + item + ')' }"
                ></div>
              </SwipeItem>
            </Swipe>
          </div>
        </div>
        <div class="tip">
          <img src="@/assets/home/weinintuijian.svg" />
          <span>为您推荐</span>
        </div>
      </div>
      <div class="good top">
        <div class="img">
          <div class="swiper-wrapper">
            <Swipe :show-indicators="false" :autoplay="3000">
              <SwipeItem v-for="(item, index) in top" :key="'top-' + index">
                <div
                  class="img-wrapper"
                  :style="{ backgroundImage: 'url(' + item + ')' }"
                ></div>
              </SwipeItem>
            </Swipe>
          </div>
        </div>
        <div class="tip">
          <img src="@/assets/home/top01.svg" />
          <span>TOP 01</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTopList } from '@/api/topList'
import { Swipe, SwipeItem } from 'vant'
export default {
  components: { Swipe, SwipeItem },
  data() {
    return {
      recommend: [],
      top: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getTopList().then((res) => {
        const recommend = []
        const top = []
        res.data.forEach((item) => {
          if (item.goodsList.length) {
            recommend.push(item.goodsList[0].good.goodsImg)
          }
          if (item.goodsList.length > 1) {
            top.push(item.goodsList[1].good.goodsImg)
          }
        })
        this.recommend = recommend.slice(0, 5)
        this.top = top.slice(0, 5)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.toplist-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  width: 320px;
  padding: 20px;
  .title {
    font-size: 32px;
    font-weight: 600;
    color: #000000;
    line-height: 44px;
  }
  .subtitle {
    margin-top: 2px;
    display: inline-block;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    padding: 4px 12px;
    background: linear-gradient(135deg, #ff3636 0%, #ffb2b2 100%);
    border-radius: 13px;
  }
  .goods {
    display: flex;
    padding-top: 30px;
    .good {
      flex: 1;
      min-width: 0;
      & + .good {
        margin-left: 20px;
      }
      .img {
        position: relative;
        width: 100%;
        padding-top: 100%;
        .swiper-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          .van-swipe {
            height: 100%;
          }
          .img-wrapper {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
          }
        }
      }
      .tip {
        display: flex;
        padding: 8px 0;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        line-height: 26px;
        justify-content: center;
        border-radius: 0px 0px 12px 12px;
        img {
          width: 20px;
          height: auto;
          margin-right: 2px;
        }
      }
      &.recommend .tip {
        background-color: #e82035;
      }
      &.top .tip {
        background-color: #f7b500;
      }
    }
  }
}
</style>